"use client";

import { c as _c } from "react/compiler-runtime";
import { useCarePlanContext } from "./care-plan";
function formatGap(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  if (minutes < 1440) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m ? `${h}h ${m}m` : `${h}h`;
  }
  const days = Math.floor(minutes / 1440);
  if (days < 7) return days === 1 ? "1 day" : `${days} days`;
  const weeks = Math.floor(days / 7);
  const rem = days % 7;
  if (!rem) return weeks === 1 ? "1 week" : `${weeks} weeks`;
  return `${weeks}w ${rem}d`;
}
export function DateConnector(t0) {
  const $ = _c(14);
  const {
    minutesGap
  } = t0;
  const {
    config: t1
  } = useCarePlanContext();
  const {
    orientation
  } = t1;
  let t2;
  if ($[0] !== minutesGap) {
    t2 = minutesGap !== undefined && minutesGap >= 0 ? minutesGap === 0 ? "Immediately" : formatGap(minutesGap) : null;
    $[0] = minutesGap;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const label = t2;
  if (orientation === "horizontal") {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="h-px w-full bg-border" />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== label) {
      t4 = label && <span data-care-plan-connector-label={true} className="whitespace-nowrap text-tiny text-foreground-muted">{label}</span>;
      $[3] = label;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="h-px w-full bg-border" />;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t4) {
      t6 = <div className="flex shrink-0 items-center gap-1 w-20">{t3}{t4}{t5}</div>;
      $[6] = t4;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-2 w-px bg-border" />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== label) {
    t4 = label && <span data-care-plan-connector-label={true} className="text-tiny text-foreground-muted">{label}</span>;
    $[9] = label;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-2 w-px bg-border" />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4) {
    t6 = <div className="flex flex-col items-center py-1">{t3}{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}